import { buildHtmlContext, buildHtmlOptions, Html } from "@chorda/core";
import * as React from "react";
import { createReactRenderer } from "./renderer";
export const ChordaStandalone = (props) => {
    const html = new Html(buildHtmlOptions(props.blueprint), Object.assign(Object.assign({}, props.context), buildHtmlContext(createReactRenderer())));
    const ref = (el) => {
        if (el) {
            html.attach(el);
        }
        else {
            html.detach();
        }
    };
    return React.createElement('div', {
        ref
    });
};
